import React from 'react';
import { Section } from './Section';
import { AlertCircleIcon, BatteryWarningIcon, ScaleIcon, SearchXIcon, UtensilsCrossedIcon, WalletIcon } from 'lucide-react';
const problems = [{
  icon: <AlertCircleIcon className="w-6 h-6" data-id="element-238" />,
  text: 'Te diagnosticaron hipotiroidismo, hipertiroidismo o Hashimoto y nadie te explicó claramente qué puedes comer y qué no.'
}, {
  icon: <ScaleIcon className="w-6 h-6" data-id="element-239" />,
  text: 'El peso sube sin freno, tu metabolismo parece estancado y las dietas tradicionales simplemente no te funcionan.'
}, {
  icon: <SearchXIcon className="w-6 h-6" data-id="element-240" />,
  text: 'Buscas información en internet y terminas más confundida: ¿el gluten es malo?, ¿la soja afecta?, ¿qué pasa con los lácteos?'
}, {
  icon: <UtensilsCrossedIcon className="w-6 h-6" data-id="element-241" />,
  text: "Sientes que comer 'saludable' para tu tiroides es aburrido, sin sabor y terminas preparando siempre lo mismo."
}, {
  icon: <BatteryWarningIcon className="w-6 h-6" data-id="element-242" />,
  text: 'La hinchazón, la caída del cabello, la piel seca y ese cansancio profundo que no se va ni durmiendo 8 horas.'
}, {
  icon: <WalletIcon className="w-6 h-6" data-id="element-243" />,
  text: 'Has gastado dinero en suplementos y consultas, pero sigues sin un plan de comidas práctico, rico y fácil para el día a día.'
}];
export const Problem = () => {
  return <Section className="bg-white" data-id="element-244">
      <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-245">
        <h2 className="text-3xl md:text-4xl font-bold text-stone-900 mb-4" data-id="element-246">
          ¿Te resulta familiar alguna de estas situaciones?
        </h2>
        <p className="text-lg text-stone-600" data-id="element-247">
          Vivir con una condición tiroidea no debería significar vivir a dieta o
          sintiéndote mal todos los días.
        </p>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-248">
        {problems.map((problem, idx) => <div key={idx} className="bg-stone-50 p-6 rounded-2xl border border-stone-100 hover:border-brand-200 transition-colors" data-id="element-249">
            <div className="w-12 h-12 bg-brand-100 text-brand-700 rounded-xl flex items-center justify-center mb-4" data-id="element-250">
              {problem.icon}
            </div>
            <p className="text-stone-700 leading-relaxed" data-id="element-251">{problem.text}</p>
          </div>)}
      </div>
    </Section>;
};